export var StaticAdviceId;
(function (StaticAdviceId) {
    StaticAdviceId["B12Vitamin"] = "b12-vitamin";
    StaticAdviceId["Omega3"] = "omega-3";
})(StaticAdviceId || (StaticAdviceId = {}));
